import { toast } from 'react-hot-toast';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addProduct } from '../services';
import { useBrandStrategyStore } from '../store/brand-strategy-store';
import { Product } from '../types';

export const useAddProduct = (projectId: string) => {
  const { brandStrategyId } = useBrandStrategyStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: Omit<Product, 'id'>) => {
      if (!brandStrategyId) {
        throw new Error('Brand strategy ID is required');
      }

      const response = await addProduct(
        projectId,
        brandStrategyId,
        data as Product
      );
      return response.data;
    },
    onSuccess: (data) => {
      // Update the cache by adding the new product
      queryClient.setQueryData(
        ['value-proposition', projectId],
        (oldData: any) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            data: {
              ...oldData.data,
              products: [...(oldData.data.products || []), data],
            },
          };
        }
      );

      // Also invalidate the main brand strategy query
      queryClient.invalidateQueries({ queryKey: ['brandStrategy', projectId] });
    },
    onError: (error) => {
      console.error('Error adding product:', error);
      toast.error('Failed to add product');
    },
  });
};
